import radioConfig from "../config/radioConfig";
import { useAudioPlayer } from "../context/AudioPlayerContext";

export const MobileBottomBar = () => {
  const { isPlaying, isLoading, toggle } = useAudioPlayer();
  if (!radioConfig.showMobileBottomBar) return null;

  return (
    <div
      data-testid="mobile-bottom-bar"
      style={{ paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))' }}
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-[#070A0F]/95 backdrop-blur-xl border-t border-cyan-500/30 px-4 py-3 flex items-center justify-between gap-3 shadow-[0_-10px_30px_rgba(0,0,0,0.8)]"
    >
      <div className="flex items-center gap-2 min-w-0">
        <span className="relative flex h-2.5 w-2.5 flex-shrink-0">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500/70" />
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500" />
        </span>
        <span className="text-xs font-mono uppercase tracking-widest text-slate-300 truncate">
          {isLoading ? "Conectando…" : isPlaying ? "Sonando · FM REAL 96.3" : "En vivo · FM REAL 96.3"}
        </span>
      </div>
      <button
        onClick={toggle}
        data-testid="mobile-bottom-listen-live-button"
        aria-label={isPlaying ? "Pausar transmisión en vivo" : "Escuchar en vivo"}
        className="flex-shrink-0 inline-flex items-center gap-1.5 bg-cyan-400 text-[#070A0F] font-bold text-sm px-4 py-2.5 rounded-full shadow-[0_0_20px_rgba(0,229,255,0.4)]"
      >
        {isLoading ? "CONECTANDO…" : isPlaying ? "⏸ PAUSAR" : "▶ ESCUCHÁ"}
      </button>
    </div>
  );
};

export default MobileBottomBar;
